(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('flyers', {
            parent: 'admin',
            url: '/flyers',
            data: {
                authorities: ['STORE_READ_FLYER'],
                pageTitle: 'flyers.home.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/flyers/flyers.html',
                    controller: 'FlyersController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                type: null,
                brand: null,
                category: null
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('flyers');
                    $translatePartialLoader.addPart('brand');
                    $translatePartialLoader.addPart('color');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('flyers.new', {
            url: '/new',
            data: {
                pageTitle: 'flyers.new.title',
                authorities: ['STORE_CREATE_FLYER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/flyers/flyers-form.html',
                    controller: 'FlyersFormController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('flyers');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('brand');
                    $translatePartialLoader.addPart('color');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('categorys');
                    return $translate.refresh();
                }]
            }
        })
            .state('flyers.edit', {
                url: '/edit/{id}',
                data: {
                    pageTitle: 'flyers.edit.title',
                    authorities: ['STORE_UPDATE_FLYER']
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/flyers/flyers-form.html',
                        controller: 'FlyersFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('brand');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('categorys');
                        return $translate.refresh();
                    }]
                }
            })
        .state('flyers-detail', {
            parent: 'flyers',
            url: '/{id}',
            data: {
                authorities: ['STORE_READ_FLYER', 'STORE_UPDATE_FLYER'],
                pageTitle: 'flyers.detail.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/flyers/flyers-detail.html',
                    controller: 'FlyersDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('flyers');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('store-management');
                    return $translate.refresh();
                }]
            }
        }).state('flyers.import', {
            parent: 'app',
            url: '/flyers-import',
            data: {
                pageTitle: 'flyers.import.title',
                authorities: ['STORE_CREATE_FLYER'],
                specialClass: "md-skin fixed-nav"
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/flyers/import/flyer-import.html',
                    controller: 'FlyerImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('flyers');
                    return $translate.refresh();
                }]
            }
        }).state('flyers.import-hub', {
            parent: 'app',
            url: '/import-hub',
            data: {
                pageTitle: 'flyers.import-hub.title',
                authorities: ['STORE_CREATE_FLYER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/flyers/import-hub/import-hub.html',
                    controller: 'FlyersImportHubController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('flyers');
                    return $translate.refresh();
                }]
            }
        }).state('flyers.import-hub.select-flyers', {
            parent: 'app',
            url: '/select-flyers',
            data: {
                pageTitle: 'flyers.import-hub.select-flyers.title',
                authorities: ['STORE_CREATE_FLYER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/flyers/import-hub/select-flyers/select-flyers.html',
                    controller: 'FlyersImportHubSelectFlyerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('flyers');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
